const vipRoutes = [
  {
    path: '/vip/buy',
    name: 'VipBuy',
    component: () => import('@/views/vip/vip-buy.vue'),
    meta: {
      layout: 'DefaultLayout',
      title: '会员购买',
      cache: true,
      pageType: 'public'
    }
  }
]

export default vipRoutes
